import { observable, computed, runInAction, action } from "mobx";
import { TemplateModel } from "./TemplateModel";
import Api from "../services/Api";
import example_template_1 from "../example_templates/example_1.json";
import example_template_2 from "../example_templates/example_2.json";
import example_template_3 from "../example_templates/example_3.json";
class TemplatesStore {
  api: Api;

  readonly DEFAULT_PAGE_SIZE = 30;
  @observable pageSize: number = this.DEFAULT_PAGE_SIZE;
  @observable total: number = 0;
  @observable currentPageNumber: number = 1;
  @observable currentTemplate: TemplateModel | null | undefined = null;
  // @observable templates: { [key: string]: TemplateModel[] } = {};
  @observable templates: TemplateModel[] = [];

  exampleTemplates: TemplateModel[] = [
    this.create({
      json: example_template_1,
      name: "Example 1",
      updateAt: new Date(),
      screenshot_path:'bd32cff57e9494711cae4640bb0ab4a1.jpeg',
    }),
    this.create({
      json: example_template_2,
      name: "Example 2",
      updateAt: new Date(),
      screenshot_path:'f3199201c56850847e1316698f06c6a2.jpeg',
    }),
    this.create({
      json: example_template_3,
      name: "Example 3",
      updateAt: new Date(),
      screenshot_path:'857b72f6762791f6a228bd71dc2def70.jpeg',
    })
  ];

  constructor(api: Api) {
    this.api = api;
  }

  async getTemplates({
    page = 1,
    pageSize = this.DEFAULT_PAGE_SIZE
  }: {
    page?: number;
    pageSize?: number;
  }) {
    pageSize = Math.max(this.DEFAULT_PAGE_SIZE, pageSize);
    page = Math.max(1, page);

    const offset = Math.max(0, (page - 1) * pageSize - 1);
    const limit = page === 1 ? pageSize - 1 : pageSize;
    const response: any = await this.api.getTemplates(offset, limit);

    runInAction(() => {
      let {
        data: { templates, total }
      } = response;
      if (templates) {
        // templates = [...this.exampleTemplates, ...templates];
        this.templates = templates.map((json: any) => this.create(json));
      }
      this.total = total;
      this.currentPageNumber = page;
      this.pageSize = pageSize;
    });
  }

  @action setCurrentPageNumber = (page: number) => {
    this.currentPageNumber = page;
  };

  @computed get currentPage() {
    return this.templates[this.currentPageNumber] || [];
  }

  getTemplate = async (id: number): Promise<TemplateModel | null> => {
    const template = Object.values(this.templates)
      .reduce((templates: any[], page: any) => templates.concat(page), [])
      .find((template: any) => template.id === id);

    if (template) {
      return template;
    }

    try {
      const response = await this.api.getTemplate(id);
      if (response.status !== 200 || !response.data.template) {
        return null;
      }
      return this.create(response.data.template);
    } catch (err) {}
    return null;
  };

  create(json?: any) {
    const template = new TemplateModel(this);
    if (json) {
      template.updateFromJson(json);
    }
    return template;
  }
  // updateTodoFromServer(json: any) {
  //   const template = this.currentPage.find(
  //     (template: TemplateModel) => template.id === json.id
  //   );
  //   if (!template) {
  //     return;
  //   }
  //   template.updateFromJson(json);
  //   return template;
  // }

  @action onDelete = (template: TemplateModel) => {
    this.templates = this.templates.filter(
      (_template: TemplateModel) => _template.id !== template.id
    );
  };

  @action onClone = (template: TemplateModel) => {
    this.templates.unshift(template);
  };
}

export default TemplatesStore;
